(function () {
  function initMegaMenuTiered(root) {
    if (!root || root.dataset.tieredInitialized === 'true') return;
    root.dataset.tieredInitialized = 'true';

    const seriesItems = root.querySelectorAll('[data-series-index]');
    const panels = root.querySelectorAll('[data-series-panel]');
    const titleEl = root.querySelector('[data-mega-menu-heading]');

    if (!seriesItems.length) return;

    function activateSeries(index) {
      seriesItems.forEach((item, i) => {
        const isActive = i === index;
        item.classList.toggle('is-active', isActive);
        if (item.hasAttribute('aria-controls')) {
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      panels.forEach((panel, i) => {
        const isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      const activeItem = seriesItems[index];
      if (!activeItem) return;

      const title =
        activeItem.dataset.seriesTitle ||
        activeItem.querySelector('.mega-menu-tiered__series-item-text')?.textContent?.trim() ||
        '';

      if (titleEl) titleEl.textContent = title;
    }

    seriesItems.forEach((item, index) => {
      item.addEventListener('mouseenter', () => activateSeries(index));
      item.addEventListener('focus', () => activateSeries(index));
    });

    activateSeries(0);
  }

  function initAll() {
    document.querySelectorAll('[data-mega-menu-tiered]').forEach(initMegaMenuTiered);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('section:cached', initAll);

  const tieredObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches?.('[data-mega-menu-tiered]')) {
          initMegaMenuTiered(node);
        }
        node.querySelectorAll?.('[data-mega-menu-tiered]').forEach(initMegaMenuTiered);
      });
    });
  });

  tieredObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
